import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_RICH_TEXT_EDITOR_LINK_ATTRIBUTES':
    case 'UPDATE_RICH_TEXT_EDITOR_IMAGE_ATTRIBUTES':
    case 'UPDATE_RICH_TEXT_EDITOR_VIDEO_ATTRIBUTES':
    case 'UPDATE_RICH_TEXT_EDITOR_AUDIO_ATTRIBUTES':
    case 'UPDATE_RICH_TEXT_EDITOR_IFRAME_ATTRIBUTES': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
